import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import { useSearchParams } from "react-router-dom";
import {
  BankStatementsModule,
  useBankStatements,
} from "../../../components/BankStatements";
import { UnderwritingSteps } from "../../../interfaces/interfaces";
import {
  UnderwritingFormContext,
  UnderwritingFormContextType,
} from "../context/UnderwritingFormContext";
import styles from "./UploadDocuments.module.scss";

type Props = {
  setFormPristine: (value: boolean) => void;
};

const UploadDocuments = forwardRef(
  ({ setFormPristine }: Props, ref) => {
    const rootRef = useRef<HTMLDivElement | null>(null);
    const [searchParams] = useSearchParams();
    const {
      formData,
      setStepValidity,
    } = useContext(UnderwritingFormContext) as UnderwritingFormContextType;
    const {
      canProceed,
      hasLocalWork,
      state,
    } = useBankStatements();

    useEffect(() => {
      setFormPristine(!hasLocalWork && !state.submittedInSession);
      setStepValidity(UnderwritingSteps.documents as any, canProceed);
    }, [
      canProceed,
      hasLocalWork,
      setFormPristine,
      setStepValidity,
      state.submittedInSession,
    ]);

    useEffect(() => {
      if (searchParams.get("error") !== "true") return;
      rootRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, [searchParams]);

    useImperativeHandle(
      ref,
      () => ({
        submitForm: async () => ({
          success: canProceed,
          values: formData,
          pristine: !state.submittedInSession,
          deleteDocIds: [],
          newDocIds: [],
        }),
      }),
      [canProceed, formData, state.submittedInSession]
    );

    return (
      <div ref={rootRef} className={styles.rootContainer}>
        <BankStatementsModule />
      </div>
    );
  }
);

UploadDocuments.displayName = "UploadDocuments";

export default UploadDocuments;
